module.exports = __webpack_public_path__ + "static/img/defaultavatar.a4d5060.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/roborobo/defaultavatar.png
// module id = Mxqw
// module chunks = 0